export const constants = {
  SUPER_ADMIN: "super_admin",
  ADMIN: "admin",
  USER: "user",
  LISTING_ROWLIMIT: 20,
};
